import { create } from "zustand";

import axios from "../helper/axios";


const useQCEStore = create((set) => ({

    newEVID:null, 
    allJDEvals: null,
    allJDEvalsStats:null,
    allJDEvalsQuestions:null,
    allJDEvalsQuestionsBackup:null,
    updateFlagQ:false,
    updateFilterFlag:false,
    jdQuestionBanDB:null,
    jdQuestionBankDbStats:null,
    evalStats:null,
    evalCategoryStats:null,
    domainArr: null,
    totalQ:0,
    allEvalCategory:null,

    CreateNewEval: async (body) => {
        try {
            console.log(body);
            var userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/qceNewEvalReqGeneralSettingReq/${userData.qhoid}/${userData.qhuid}/${body.qhjid}`,
                body.jasonValues
            );
            set({ newEVID: response.data.data,updateFlagQ:true });

            console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
        }
    },         
   AddQuestionsToQBank: async (body) => {
        try {
            console.log(body.jasonValues);
            var userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/qceEvalQBankAddQuestionReq/${userData.qhoid}/${userData.qhuid}/${body.qhjid}`,
                body.jasonValues
            );
            console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
        }
    }, 
    AddQuestionsToEval: async (body) => {
        try {
            console.log(body.jasonValues);
            var userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/qceEvalQsetQuestionReq/${userData.qhoid}/${userData.qhuid}/${body.qhjid}/${body.ev_id}`,
                body.jasonValues
            );
            set({ updateFlagQ:true });

            console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
        }
    }, 

    LinkQuestionsToEval: async (body) => {
        try {
            console.log(body.jasonValues);
            var userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/qceEvalLinkQuestionsReq/${userData.qhoid}/${userData.qhuid}/${body.qhjid}/${body.ev_id}`,
                body.jasonValues
            );
            console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
        }
    },     

    updateEvalState: async (body) => {
        try {
            console.log(body.jasonValues);
            var userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/qceEvalUpdateStateReq/${userData.qhoid}/${userData.qhuid}/${body.qhjid}/${body.ev_id}`,
                body.jasonValues
            );
            set({ updateFlagQ:true });
            console.log(response.data);
        } catch (error) {
            set({ jdCreationError: error });
        }
    },      
    updateEvalSkills: async (body) => {
        try {
           var userData = JSON.parse(localStorage.getItem("userDetails"));
           const response = await axios.post(
                `/qceNewEvalReqSkillUpdateReq/${userData.qhoid}/${userData.qhuid}/jds/${body.qhjid}/${body.ev_id}`,
                body.jasonValues
            );           
            //console.log(response.data);
            set({ selectedProfileResume: response?.data });
        } catch (err) {
            console.error(err);
        }
    },
   
    getJDAllEvals: async (jdid,setCurrentAllJDEvals) => {
        try {
            var userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(`/qceGetCurrentEvals/${userData.qhoid}/${userData.qhuid}/jds/${jdid}`);
            console.log("All Evals",response.data);
            //console.log(response.data.data);
            //console.log(response.data.eStatsArr);

            set({allJDEvals: response?.data.data ,
                 allJDEvalsStats: response?.data.stats,
                 allJDEvalsQuestions: response?.data.questions,
                 allJDEvalsQuestionsBackup: null,
                 updateFilterFlag:false,                  
                 updateFlagQ:false});
            if(setCurrentAllJDEvals !=null)
                setCurrentAllJDEvals(response.data.data)
             
        } catch (err) {
            console.log("Evals Data Error",err);
            console.log(err.response.data.jd);
            console.error(err);
        }
    },
    setFiterFlagQuestions: async () => {
        try {
            set({  updateFilterFlag:true });

        } catch (err) {
            console.error(err);
        }
    },
    resetFiterFlagQuestions: async () => {
        try {
            set({  updateFilterFlag:false      });

        } catch (err) {
            console.error(err);
        }
    },
    CandidateEvalCommunication: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/qceCommunication/${userData.qhoid}/${userData.qhuid}/jds/${body.qhjid}/${body.ev_id}`,
                body.jasonValues
            );
            console.log(response.data);
        } catch (error) {
            console.log(error);
        }
    },  
    getQuestionBankForJD: async (body,setLocalQSet,setQbCount) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            console.log(body);
            const response = await axios.post(
                `/qceGetQuestionBankForJD/${userData.qhoid}/${userData.qhuid}/jds/${body.qhjid}`,
                body.jasonValues
            );
            console.log(response.data);

            set({  jdQuestionBanDB:response.data.data});
            if(setLocalQSet != null){
               if (response.data.data == null) {
                 setLocalQSet([])
                 setQbCount(0)
               }else{
                 setLocalQSet([...response.data.data])
                 setQbCount(response.data.totalQ)
               }
            }
                

        } catch (error) {
            console.log(error);
        }
    }, 
    getQuestionBankForJDStats: async (body,setQBankStats) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/qceGetQuestionBankForJDStats/${userData.qhoid}/${userData.qhuid}/jds/${body.qhjid}`
            );
            console.log(response.data);
            set({  jdQuestionBankDbStats:response.data.data });
            if(setQBankStats != null)
                setQBankStats(response.data.data)            
        } catch (error) {
            console.log(error);
        }
    },   
    getEvalCategoryStats: async (body,setEvalCategoryStats) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/qceEvalCategoryStatsReq/${userData.qhoid}/${userData.qhuid}/${body.category}`
            );
            console.log(response.data);
            set({  evalCategoryStats:response.data.data });
            if(setEvalCategoryStats != null)
                setEvalCategoryStats(response.data.data)            
        } catch (error) {
            console.log(error);
        }
    }, 
    getEvalStats: async (setEvalStats) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/qceEvalStatsReq/${userData.qhoid}/${userData.qhuid}`
            );
            console.log(response.data);
            set({  evalStats:response.data.data });
            if(setEvalStats != null)
                setEvalStats(response.data.data) 
                set({ domainArr: response.data.domainArray })           
        } catch (error) {
            console.log(error);
        }
    },    
    
    getAllEvalCategory: async (setAllEvalCategory) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/getAllEvalCategory/${userData.qhoid}`
            );
            console.log(response.data);  
            set({ allEvalCategory: response.data.data });
        } catch (error) {
            console.log(error);
        }
    },
}));

export default useQCEStore;
